import { FilterVariants } from "../../utils/typings";
import { SimpleSelectFilter } from "./simpleSelectFilter";
import { SimpleTextFilter } from "./simpleTextFilter";

interface FilterProps {
  data: any;
  variant?: FilterVariants;
  onChange: (event: any) => void;
}

export const Filter = ({ variant, data, onChange }: FilterProps) => {
  switch (variant) {
    case FilterVariants.Select:
      return <SimpleSelectFilter options={data} onFilterChange={onChange} />;
    default:
      return <SimpleTextFilter id={data} onFilterChange={onChange} />;
  }
};
